import { PetSummary } from "./types.ts";
import PetFilterControls from "./filters/PetFilterControls.tsx";
import {usePetFilterControls} from "./filters/usePetFilterControls.ts";
import AdoptablePetPreview from "./AdoptablePetPreview.tsx";
import NoPetsFound from "./NoPetsFound.tsx";

type AdoptablePetGridProps = {
  petSummaries: PetSummary[];
};

export default function AdoptablePetGrid({
  petSummaries,
}: AdoptablePetGridProps) {
  // state for petSummaries and the filtered versions petSummariesFiltered
  const { filteredPets, petFilterControlsProps } = usePetFilterControls({
    petSummaries,
  });

  return (
    <section className="mx-auto">
      <PetFilterControls {...petFilterControlsProps} />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 max-w-[1000px] lg:max-w-[1280px] mx-auto">
        {filteredPets.length > 0 ? (
          filteredPets.map((item) => (
            <AdoptablePetPreview key={item.id} item={item} />
          ))
        ) : (
          <NoPetsFound/>
        )}
      </div>
    </section>
  );
}
